import { uuid } from '../../helpers'

// Remove after finish ticket BS-222
export function submitToOldApi({
    body = {},
    cognitoUser,
    creds,
    errorCallback = () => {},
    method = 'GET',
    path,
    platform, // Only required for Supplier and Management due to different account types (admins & managers)
    query = {},
    startCallback = () => {},
    successCallback = () => {},
    url,
    userProfile = {},
    withoutUserId = false,
}) {
    startCallback()
    const apigClientFactory = require('aws-api-gateway-client').default

    // Invoking APIGateway with IAM credentials
    const apigClient = apigClientFactory.newClient({
        invokeUrl: url, // REQUIRED
        accessKey: creds.accessKeyId, // REQUIRED
        secretKey: creds.secretAccessKey, // REQUIRED
        sessionToken: creds.sessionToken, // OPTIONAL: If you are using temporary credentials you must include the session token
        region: 'eu-west-2', // REQUIRED: The region where the API is deployed.
        systemClockOffset: 0, // OPTIONAL: An offset value in milliseconds to apply to signing time
        retries: 4, // OPTIONAL: Number of times to retry before failing. Uses axon-retry plugin.
        // OPTIONAL: Callback to further control if request should be retried.  Uses axon-retry plugin.
        retryCondition: err => err.response && err.response.status === 500,
    })

    if (!cognitoUser) {
        return Promise.reject('[submitToOldApi] Error with cognitoUser')
    }

    const { clientId, employeeId, pilotTag } = userProfile
    let supplierAccountType, managementAccountType

    if (platform === 'supplier') {
        supplierAccountType = cognitoUser.attributes['custom:type'] === 'supplier-admin' ? 'supplier-admin' : 'supplier'
    }

    if (platform === 'management') {
        managementAccountType = cognitoUser.attributes['custom:type'] === 'manager' ? 'manager' : 'admin'
    }

    const pathParams = {
        trace: uuid(), // Used for debugging on BE
        ...(clientId && { clientId }),
        ...(pilotTag && { pilotTag }),
        ...(employeeId && { employeeId }),
        ...(managementAccountType && { type: managementAccountType }),
        ...(supplierAccountType && { userType: supplierAccountType }),
        ...(!withoutUserId && { userId: cognitoUser.attributes?.sub || cognitoUser.username }),
        ...query,
    }

    const additionalParams = {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        queryParams: {
            ...pathParams,
        },
    }

    console.log(`%c[submitToOldApi] ${path} REQUEST`, 'color: #66f', {
        pathParams,
        method,
        additionalParams,
        body,
    })

    return apigClient
        .invokeApi(pathParams, path, method, additionalParams, body)
        .then(response => {
            if ((response.data && typeof response.data === 'object' && 'errorType' in response.data) || response?.data?.statusCode > 400) {
                return Promise.reject(response.response || response.data)
            } else {
                console.log(`%c[submitToOldApi] ${path} %cSUCCESS`, 'color: #66f', 'color: #0f0', response.data)
                successCallback(response.data)
                return Promise.resolve(response.data)
            }
        })
        .catch(response => {
            console.log(`%c[submitToOldApi] ${path} %cERROR`, 'color: #66f', 'color: #f00', response)

            try {
                if (response.response) {
                    errorCallback(response.response)
                    return Promise.reject(response.response)
                }
                if (response?.errorMessage) {
                    errorCallback(response.errorMessage)
                    return Promise.reject(response.errorMessage)
                }
                if (response?.message) {
                    errorCallback(response.message)
                    return Promise.reject(response.message)
                }
                if (typeof response.body === 'string') {
                    errorCallback(JSON.parse(response.body))
                    return Promise.reject(JSON.parse(response.body))
                }
            } catch (error) {
                errorCallback('Something went wrong.')
                return Promise.reject('Something went wrong.')
            }
        })
}

// Remove after finish ticket BS-222
export function submitToOldOpenApi({
    body = {},
    errorCallback = () => {},
    method = 'GET',
    path,
    query = {},
    startCallback = () => {},
    successCallback = () => {},
    url,
}) {
    startCallback()
    const apigClientFactory = require('aws-api-gateway-client').default

    const pathParams = {
        trace: uuid(), // Used for debugging on BE

        ...query,
    }

    const additionalParams = {
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        queryParams: {
            ...pathParams,
        },
    }

    const apigClient = apigClientFactory.newClient({
        invokeUrl: url,
    })

    console.log(`%c[submitToOldOpenApi] ${path} REQUEST`, 'color: #66f', {
        pathParams,
        method,
        additionalParams,
        body,
    })

    apigClient
        .invokeApi(pathParams, path, method, additionalParams, body)
        .then(response => {
            if (response.data && typeof response.data === 'object' && 'errorType' in response.data) {
                errorCallback(response.response || response.data)
                console.log(`%c[submitToOldOpenApi] ${path} %cERROR in then()`, 'color: #66f', 'color: #f00', response)
            } else {
                successCallback(response.data)
                console.log(`%c[submitToOldOpenApi] ${path} %cSUCCESS`, 'color: #66f', 'color: #0f0', response.data)
            }
        })
        .catch(response => {
            console.log(`%c[submitToOldOpenApi] ${path} %cERROR in catch()`, 'color: #66f', 'color: #f00', response)

            try {
                if (response.response) {
                    errorCallback(response.response)
                }
                if (response.errorMessage) {
                    errorCallback(response.errorMessage)
                }
            } catch (error) {
                errorCallback('Something went wrong.')
            }
        })
}

export const submitToApi = async ({
    body = {},
    cognitoUser,
    creds,
    method = 'GET',
    path,
    platform, // Only required for Supplier and Management due to different account types (admins & managers)
    query = {},
    url,
    userProfile = {},
    withoutUserId = false,
}) => {
    const apigClientFactory = require('aws-api-gateway-client').default

    // Invoking APIGateway with IAM credentials
    const apigClient = apigClientFactory.newClient({
        invokeUrl: url, // REQUIRED
        accessKey: creds.accessKeyId, // REQUIRED
        secretKey: creds.secretAccessKey, // REQUIRED
        sessionToken: creds.sessionToken, // OPTIONAL: If you are using temporary credentials you must include the session token
        region: 'eu-west-2', // REQUIRED: The region where the API is deployed.
        systemClockOffset: 0, // OPTIONAL: An offset value in milliseconds to apply to signing time
        retries: 4, // OPTIONAL: Number of times to retry before failing. Uses axon-retry plugin.
        // OPTIONAL: Callback to further control if request should be retried.  Uses axon-retry plugin.
        retryCondition: err => err.response && err.response.status === 500,
    })

    if (!cognitoUser) {
        return Promise.reject('[submitToApi] Error with cognitoUser')
    }

    const { clientId, employeeId, pilotTag } = userProfile
    let supplierAccountType, managementAccountType

    if (platform === 'supplier') {
        supplierAccountType = cognitoUser.attributes['custom:type'] === 'supplier-admin' ? 'supplier-admin' : 'supplier'
    }

    if (platform === 'management') {
        managementAccountType = cognitoUser.attributes['custom:type'] === 'manager' ? 'manager' : 'admin'
    }

    const pathParams = {
        trace: uuid(), // Used for debugging on BE
        ...(clientId && { clientId }),
        ...(pilotTag && { pilotTag }),
        ...(employeeId && { employeeId }),
        ...(managementAccountType && { type: managementAccountType }),
        ...(supplierAccountType && { userType: supplierAccountType }),
        ...(!withoutUserId && { userId: cognitoUser.attributes?.sub || cognitoUser.username }),
        ...query,
    }

    const additionalParams = {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        queryParams: {
            ...pathParams,
        },
    }

    console.log(`%c[submitToApi] ${method} ${path}`, 'color: #66f', {
        additionalParams,
        body,
    })

    try {
        const response = await apigClient.invokeApi(pathParams, path, method, additionalParams, body)
        console.log(`%c[submitToApi] ${method} ${path} %cSUCCESS`, 'color: #66f', 'color: #0f0', response.data)

        // TODO: could remove whole condition when BS-222 will be deployed on prod
        if (typeof response.data === 'object' && 'errorMessage' in response.data) {
            return Promise.reject(response.data.errorMessage)
        }

        return Promise.resolve(response.data)
    } catch (error) {
        console.log(`%c[submitToApi] ${method} ${path} %cERROR`, 'color: #66f', 'color: #f00', error, error?.response)

        if (error.response === undefined && error.toString) {
            console.warn('[submitToApi] e.g. HTTP method is incorrect', error)
            return Promise.reject(error.toString())
        }

        if (error?.response?.data && typeof error.response.data === 'string') {
            console.warn('[submitToApi] API Gateway error (invalid JSON, do not parse)', error)
            return Promise.reject(error.response.data)
        }
        if (error?.response?.data && 'errorMessage' in error?.response?.data) {
            console.warn('[submitToApi] Lambda error', error)
            return Promise.reject(error.response.data.errorMessage)
        }
        if ('errorMessage' in error) {
            console.warn('[submitToApi] Lambda error', error)
            return Promise.reject(error.errorMessage)
        }

        return Promise.reject('Something went really wrong.')
    }
}

export const submitToOpenApi = async ({ body = {}, method = 'GET', path, query = {}, url }) => {
    const apigClientFactory = require('aws-api-gateway-client').default

    const pathParams = {
        trace: uuid(), // Used for debugging on BE
        ...query,
    }

    const additionalParams = {
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        queryParams: {
            ...pathParams,
        },
    }

    const apigClient = apigClientFactory.newClient({ invokeUrl: url })

    console.log(`%c[submitToOpenApi] ${method} ${path}`, 'color: #66f', {
        additionalParams,
        body,
    })

    try {
        const response = await apigClient.invokeApi(pathParams, path, method, additionalParams, body)
        console.log(`%c[submitToOpenApi] ${path} %cSUCCESS`, 'color: #66f', 'color: #0f0', response.data)
        return Promise.resolve(response.data)
    } catch (error) {
        console.log(`%c[submitToOpenApi] ${path} %cERROR in catch()`, 'color: #66f', 'color: #f00', error, error?.response)

        // e.g. HTTP method is incorrect
        if (error.response === undefined && error.toString) {
            console.warn('[submitToApi] e.g. HTTP method is incorrect', error)
            return Promise.reject(error.toString())
        }

        // API Gateway error (invalid JSON, do not parse)
        if (error?.response?.data && typeof error.response.data === 'string') {
            console.warn('[submitToApi] API Gateway error (invalid JSON, do not parse)', error)
            return Promise.reject(error.response.data)
        }

        // Lambda error
        if ('errorMessage' in error) {
            console.warn('[submitToApi] Lambda error', error)
            return Promise.reject(error.errorMessage)
        }

        return Promise.reject('Something went really wrong.')
    }
}
